'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.response.service
 * @description
 * # basecontroller.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .controller('BaseController', function($http, $location, $q, vm, cfpLoadingBar,
    BaseService, FlashService, errorService) {

    vm.baseActivate = BaseActivate;
    vm.isAuthorized = isAuthorized;
    vm.requestStart = RequestStart;
    vm.requestSuccess = RequestSuccess;
    vm.requestFailure = RequestFailure;
    vm.requestComplete = RequestComplete;

    return vm;

    function BaseActivate(activate) {
      this.refresh = activate;
      return $q.resolve(isAuthorized().then(activate));
    }

    function isAuthorized() {
      // DO ANY ACCESS CONTROLS HERE
      var b = 1 + 1;
      return $q.resolve(b);
    }

    //  Request
    function RequestStart() {
      this.inprogress = true;
      return $q.resolve(cfpLoadingBar.start());
    }

    function RequestSuccess(message) {
      return $q.resolve(FlashService.Success(message));
    }

    function RequestFailure(error) {
      this.inprogress = false;
      return $q.resolve(FlashService.ErrorMessage(error));
    }

    function RequestComplete() {
      this.inprogress = false;
      return $q.resolve(cfpLoadingBar.complete());
    }

  });
